import React from 'react';
import { Starfield } from '../components/v2';
import Nav from '../components/v2/Nav';
import Hero from '../components/v2/sections/Hero';
import Story from '../components/v2/sections/Story';
import Showcase from '../components/v2/sections/Showcase';
import FriendMode from '../components/v2/sections/FriendMode';
import Privacy from '../components/v2/sections/Privacy';
import Proof from '../components/v2/sections/Proof';
import FinalCTA from '../components/v2/sections/FinalCTA';
import Footer from '../components/v2/sections/Footer';

/**
 * crossedpaths.ai — one page, one job: App Store downloads.
 *
 * A case file that turns out to be a love story. Every section is an exhibit,
 * every number is evidence. The romance is in the facts, so the page states
 * the facts and lets them be romantic.
 *
 * The scroll alternates band weight so the page breathes — nothing is the
 * same height twice:
 *
 *   §00 HERO      full-bleed spectacle, the three-second hook
 *   §01 STORY     tall, quiet, type-dominant, one huge numeral
 *   §02 SHOWCASE  wide, horizontal, image-dominant — the only sideways band
 *   §03 FRIEND    medium, two-column, one device
 *   §04 PRIVACY   tall, near-empty, one panel, maximum void
 *   §05 PROOF     short, low, a strip
 *   §06 FINAL CTA spectacle bookend
 *   FOOTER        dense mono, quiet
 *
 * Five conversion surfaces, no more: nav, hero, end of showcase, end of
 * friend mode, final CTA. Story, Privacy and Proof deliberately carry none —
 * they build, and the band after them closes.
 *
 * There is no standalone "How It Works" section. A three-step icon strip is
 * the most conversion-dead pattern on app landing pages, and the mechanic is
 * the privacy story — so those beats live inside §04, one band doing double
 * duty.
 */
const Landing = () => (
  <div className="relative min-h-screen bg-void text-paper antialiased">
    <Starfield />
    <Nav />
    <main id="main" className="relative z-10">
      <Hero />
      <Story />
      <Showcase />
      <FriendMode />
      <Privacy />
      <Proof />
      <FinalCTA />
    </main>
    <Footer />
  </div>
);

export default Landing;
